import React from 'react';
import { graphql } from 'gatsby';
import StarFill from '@images/svg/star-fill.svg';
import StarEmpty from '@images/svg/star-empty.svg';
import Container from '@atoms/Container';
import NearestVertical from '../franchise/nearest-vertical';
import paddingDefault from '@utils/paddingDefault';
import { colors } from '../primitives/colors';

// not being used.
const ReviewGrid = ({ data }) => {
    const { settings, reviews } = data;
    const hasWidget = !!settings?.has_widget;

    const RenderRating = ({ rating }) => {
        return [...Array(5).keys()].map(i => {
            return i < rating ? (
                <StarFill width={22} height={22} key={i} />
            ) : (
                <StarEmpty width={22} height={22} key={i} />
            );
        });
    };

    return (
        <Container css={[paddingDefault(), styles.container]}>
            <div css={styles.reviewsGridContainer(hasWidget)}>
                {reviews.map(review => {
                    const { full_name, byline, quote, rating } = review.customer;

                    return (
                        <div css={styles.reviewItem} key={full_name}>
                            <div css={styles.headingOuterWrap}>
                                <div css={styles.headingWrap}>
                                    <p>{full_name}</p>
                                    <p>{byline}</p>
                                </div>
                            </div>
                            <div css={styles.ratingWrap}>
                                <RenderRating rating={rating} />
                            </div>
                            <p css={styles.quote}>{quote}</p>
                        </div>
                    );
                })}
            </div>
            {hasWidget && <NearestVertical />}
        </Container>
    );
};

const styles = {
    quote: {
        fontSize: "1.125rem",
        lineHeight: "1.75rem", color: colors.shadesBlack
    },
    ratingWrap: {
        display: "flex",
        marginBottom: "1.25rem",
        marginLeft: "0.25rem"
    },
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start"
    },
    reviewItem: {
        maxWidth: "304px"
    },
    headingWrap: {
        letterSpacing: "1.71px",
        color: colors.grey400
    },
    headingOuterWrap: {
        display: "flex",
        marginBottom: "1.5rem"
    },
    reviewsGridContainer: (hasWidget) => ({
        display: "grid",
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        gap: "2rem",
        "@media (min-width: 768px)": {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            width: hasWidget && "100%"
        },
        "@media (min-width: 1024px)": {
            gridTemplateColumns: hasWidget ? "repeat(2, minmax(0, 1fr))" : "repeat(3, minmax(0, 1fr))",
            width: hasWidget ? "66.666667%" : "100%",
            columnGap: "3rem",
            rowGap: "7rem"
        },
    }),
};

export const query = graphql`
  fragment ReviewGridData on CmsPageBuilderBlocks {
    review_grid {
      settings {
        has_widget
      }
      reviews {
        customer {
          full_name
          byline
          quote
          rating
        }
      }
    }
  }
`;

export default ReviewGrid;
